import "./Landingpage.css";
import Header from "./Header";
import Footer from "./Footer";
import SEO from "./SeoHelmet";
import metaConfig from "./SeoComponent";
import { useLocation } from "react-router-dom";

function AboutKtig() {
  const location = useLocation(); // Get the current location (path)
  const meta = metaConfig.about;
  return (
    <div>
      <SEO {...meta} />

      <div className="container-fluid  ktig_services_page position-relative p-0">
        <div className="w-100 me-3 top_head">
          <div className="top_head align-items-center"></div>
        </div>
        <Header />
      </div>
      <div className="container-fluid ktig_services_page bg-breadcrumb">
        <div
          className="container text-center py-3"
          style={{ maxWidth: "900px" }}
        >
          <ol
            className="breadcrumb d-flex justify-content-center mb-0 wow fadeInDown"
            data-wow-delay="0.3s"
          ></ol>
          <h4
            className="text-white display-4 mb-4 wow fadeInDown"
            data-wow-delay="0.1s"
          >
            CHOOSE YOUR BUSINESS INDUSTRY
          </h4>
        </div>
      </div>

      <div
        className="modal fade"
        id="searchModal"
        tabindex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-fullscreen">
          <div className="modal-content rounded-0">
            <div className="modal-header">
              <h4 className="modal-title mb-0" id="exampleModalLabel">
                Search by keyword
              </h4>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body d-flex align-items-center">
              <div className="input-group w-75 mx-auto d-flex">
                <input
                  type="search"
                  className="form-control p-3"
                  placeholder="keywords"
                  aria-describedby="search-icon-1"
                />
                <span
                  id="search-icon-1"
                  className="input-group-text btn border p-3"
                >
                  <i className="fa fa-search text-white"></i>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="container-fluid innercontain py-3 ktig_services_page kti_details_1 overflow-hidden">
        <div className="container pt-3 ">
          <div className="row g-5 mt-0">
            <div
              className="col-lg-6 mt-0  wow fadeInRight"
              data-wow-delay="0.2s"
            >
              <div
                className="col-12 mb-0  text-left wow fadeInUp"
                data-wow-delay="0.2s"
              >
                <h3 className="display-3 text-capitalize text-white">
                  Kovai Tech India Group
                </h3>
                <p className="m-0 text-white text-left service_caption">
                  Global Link
                </p>
              </div>

              <div className="about-item">
                <p
                  className="mb-4 text-white"
                  style={{
                    fontFamily: "Poppins",
                    textAlign: "left",
                  }}
                >
                  Kovai Tech India Group of Company is a dynamic conglomerate
                  that brings together diverse expertise across vital sectors to
                  drive innovation and societal progress. With a robust presence
                  in financial services, education, information technology, and
                  social development.
                </p>
                <p
                  className="mb-4 text-white"
                  style={{
                    fontFamily: "Poppins",
                    textAlign: "left",
                  }}
                >
                  Kovai Tech India Group (KTIG) is committed to leveraging
                  cutting - edge technology to create innovative solutions that
                  address the challenges of tomorrow. With a vision centered on
                  progress and growth, KTIG integrates the latest technological
                  advancements to provide transformative solutions across
                  diverse sectors, including finance, education, IT, and social
                  development. By blending expertise, innovation, and a deep
                  understanding of evolving market demands, KTIG ensures that
                  businesses and communities are equipped with the tools they
                  need to thrive in an ever - changing world.
                </p>
              </div>
            </div>

            {/* <!-- Image Section --> */}
            <div
              className="col-lg-6 mt-0 ktig_lp wow fadeInLeft"
              data-wow-delay="0.2s"
            >
              <div className="about-img h-100">
                <div className="about-img_border"></div>
                <img
                  src="assets/img/event/about_ktig.png"
                  className="img-fluid w-100"
                  alt="globlelink"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="overlaygradient pt-5 pb-5 mb-5 ktig_services_page kti_details_2 container-fluid">
        <div className="container py-6">
          <div
            className="col-12 text-center mx-auto pb-2 wow fadeInUp"
            data-wow-delay="0.2s"
          >
            <h1 className="display-5 text-white text-capitalize mb-3">
              KTIG Business Group
            </h1>
          </div>

          <div
            className="col-lg-10  col-xl-10 m-auto wow fadeInRight"
            data-wow-delay="0.2s"
          >
            <div className="service-item rounded p-4 mb-4">
              <div className="d-flex">
                <div className="pe-3">
                  <div className="service-btn">
                    <i className="fas fa-assistive-listening-systems text-white fa-2x"></i>
                  </div>
                </div>
                <div>
                  <a
                    href="/kovai-tech-member-chamber"
                    className="h5 text-white d-inline-block mb-2"
                  >
                    Kovai Tech Member Chamber
                  </a>
                  <p className="small_caption">
                    Supporting | Social service | Trust
                  </p>
                  <p className="mb-0 text-white">
                    <strong>Kovai Tech Members Chamber (KTMC)</strong> is more
                    than just a networking hub; it is a thriving ecosystem
                    designed to bring together like-minded individuals and
                    organizations committed to mutual growth and positive
                    impact. By providing access to exclusive events, workshops,
                    and seminars, KTMC ensures that members are well-equipped to
                    tackle current challenges while identifying future
                    opportunities. The Chamber’s emphasis on social service
                    initiatives further reflects its commitment to not only
                    business excellence but also to making meaningful
                    contributions to society. With a diverse community of
                    professionals, KTMC creates a space where collaboration is
                    at the heart of every interaction, fostering both business
                    success and social responsibility.
                  </p>
                </div>
              </div>
            </div>
            <div className="service-item rounded p-4 mb-4">
              <div className="d-flex">
                <div className="pe-3">
                  <div className="service-btn">
                    <i className="fas fa-recycle text-white fa-2x"></i>
                  </div>
                </div>
                <div>
                  <a
                    href="https://cogniitec.com"
                    className="h5 text-white d-inline-block mb-2"
                  >
                    BNR Cogniitec Private Limited
                  </a>
                  <p className="small_caption">
                    ITES Service | Digital Marketing | Branding Services
                  </p>
                  <p className="mb-0 text-white">
                    <strong>BNR CogniItec Private Limited</strong> prides itself
                    on delivering results-driven services that enable businesses
                    to thrive in the rapidly evolving digital landscape. With a
                    strong focus on client needs, the company crafts bespoke
                    solutions that optimize business processes, enhance online
                    visibility and build lasting brand value. By leveraging
                    cutting-edge technology and data-driven strategies, BNR
                    Cogniitec ensures that clients stay ahead of the competition
                    and successfully navigate the digital transformation
                    journey. Whether through innovative digital marketing
                    campaigns, AI-powered solutions, or comprehensive branding
                    strategies, BNR Cogniitec continues to set the standard for
                    excellence in the ITES and technology-driven service
                    sectors.
                  </p>
                </div>
              </div>
            </div>
            <div className="service-item rounded p-4 mb-0">
              <div className="d-flex">
                <div className="pe-3">
                  <div className="service-btn">
                    <i className="fas fa-project-diagram text-white fa-2x"></i>
                  </div>
                </div>
                <div>
                  <a
                    href="https://www.bracadmy.com/"
                    className="h5 text-white d-inline-block mb-2"
                  >
                    BR Academy
                  </a>
                  <p className="small_caption">
                    Educational Training | Corporate Event | Campaigns
                  </p>
                  <p className="mb-0 text-white">
                    <strong>BR Academy Private Limited </strong> is committed to
                    delivering high-quality educational experiences that bridge
                    the gap between theoretical knowledge and practical
                    application. By collaborating with industry experts and
                    leveraging modern teaching methodologies, the academy equips
                    individuals with the skills necessary to excel in their
                    careers. Its comprehensive training programs cater to
                    diverse sectors, including IT, finance, marketing, and soft
                    skills, ensuring that every participant is well-prepared for
                    the challenges of today’s competitive job market. BR
                    Academy’s focus on continuous learning and development
                    positions it as a trusted partner for personal and
                    professional growth.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />

      <button
        className="btn btn-secondary btn-lg-square rounded-circle back-to-top"
        onClick={() => window.scrollTo(0, 0)}
      >
        <i className="fa fa-arrow-up"></i>
      </button>
    </div>
  );
}

export default AboutKtig;
